import React from 'react';

const IntegrationBreadcumbs = () => {
  return <div>IntegrationBreadcumbs</div>;
};

export default IntegrationBreadcumbs;
